import { ArrowRight, Filter, Grid, List, Plus, Search } from "react-feather";
import styles from "./filter.module.css";
import { Link } from "react-router-dom";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";

const PetFilter = ({ handleView, isGridView, filterData, setFilterData, setPage, setAddModalOpen }) => {
  const { getAccessTokenSilently, user, isAuthenticated } = useAuth0();
  const [filterOpen, setFilterOpen] = useState(false);
  const [propertyList, setPropertyList] = useState([]);
  const [apartmentList, setApartmentList] = useState([]);

  useEffect(() => {
    async function getProperties() {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_PAYMENT_API_URL + "v1/property-list", {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        let propertyListTemp = [{ value: "all", label: "Any", apartments: [] }].concat(response.data.data);
        setPropertyList(propertyListTemp);
      }).catch((error) => { });
    }
    getProperties();
  }, [getAccessTokenSilently]);

  return (<div className={`${styles.SearchFilterSec}`}>
    <div className={`${styles.SearchCon}`}>
      <div className={`${styles.SearchConSec}`}>
        <Search />
        <input type="text" placeholder="Search" value={filterData?.searchKey} onChange={(e) => { setFilterData((prev) => { return { ...prev, searchKey: e.target.value }; }); setPage(0); }} />
      </div>
    </div>

    <div className={`${styles.FilterSec}`}>
      <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
        <p className={`${styles.FilterTitle}`}>
          Filters
          <span onClick={(e) => setFilterOpen(false)}>
            <ArrowRight />
          </span>
        </p>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width220} CusSelectFilter Filter`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Property</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Property"
              value={filterData?.property}
              onChange={(e) => {
                setFilterData((prev) => {
                  return { ...prev, property: e.target.value };
                });

                if (e.target.value !== "all") {
                  let propertyTemp = propertyList.filter((i) => i.value === e.target.value);
                  setApartmentList([{ value: "all", label: "Any" }].concat(propertyTemp[0]?.apartments));
                } else {
                  setApartmentList([{ value: "all", label: "Any" }]);
                }
              }}
            >
              {propertyList?.map((i) => {
                return <MenuItem value={i.value}>{i.label}</MenuItem>;
              })}
            </Select>
          </FormControl>
        </div>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Apartment</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              label="Apartment"
              value={filterData?.apartment}
              onChange={(e) => {
                setFilterData((prev) => {
                  return { ...prev, apartment: e.target.value };
                });
              }}
            >
              {apartmentList.length === 0 && (<MenuItem disabled value={""}>Select Property First</MenuItem>)}
              {apartmentList?.map((i) => {
                return <MenuItem value={i.value}>{i.label}</MenuItem>;
              })}
            </Select>
          </FormControl>
        </div>
      </div>
      <div className={`${styles.ListGridBUCard}`}>
        {isGridView ? (<div className={`${styles.ListGridBUSec}`}>
          <div className={`${styles.ListGridBU} `} onClick={() => handleView("list")}>
            <List /> <span>List</span>
          </div>
          <div className={`${styles.ListGridBU} ${styles.Active}`}>
            <Grid /> <span>Grid</span>
          </div>
        </div>) : (<div className={`${styles.ListGridBUSec}`}>
          <div className={`${styles.ListGridBU}  ${styles.Active}`}>
            <List /> <span>List</span>
          </div>
          <div className={`${styles.ListGridBU}`} onClick={() => handleView("grid")}>
            <Grid /> <span>Grid</span>
          </div>
        </div>)}
      </div>
      <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}>
        <Filter />
      </Link>
      {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("pet:create") > -1 && <Link className={`${styles.AddNoteBu}`} onClick={(e) => setAddModalOpen(true)}>
        <Plus /> <span>Pet</span>
      </Link>}
    </div>
  </div>);
};

export default PetFilter;